import { isArrayOf, isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isMediaInfoRawData, MediaId, MediaInfoRawData } from "../MediaInfo.js";
import { MediaMetaData } from "../MediaMetaData.js";
import { ThumbnailResource } from "../MediaThumbnailResource.js";
import { AudioFormatRawData, isAudioFormatRawData } from "./AudioFormat.js";

export interface WaveForm {
    url: string 
}

export function isWaveForm(a: any): a is WaveForm {
    return isObject(a) && 
            ("url" in a && isString(a.url)) 

}

/**
 * informazioni grezze (provenienti da server) con le informazioni sul audio
 */
export interface AudioInfoRawData extends MediaInfoRawData<AudioFormatRawData>  {

    id: MediaId,
    title: string,
    description?: string,
    url: string,
    linkedResource?: string,
    thumbnail?: ThumbnailResource
    format: AudioFormatRawData[],
    socialInfo?: {
        share?: number,
        heart?: number,
        view?: number
    }
    meta?: MediaMetaData,
    waveForm?: WaveForm
};

/**
 * barrier per oggetti di tipo VideoInfoRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isAudioInfoRawData(obj: any): obj is AudioInfoRawData {
    return isMediaInfoRawData(obj) &&
        (hasOwnProperty(obj, 'format') && isArrayOf(obj['format'], isAudioFormatRawData)) &&
        (!hasOwnProperty(obj, 'waveForm') || isWaveForm(obj['waveForm']));
};